<template>
  <div id="cycle-table-container">
    <div class="flex-row just-between">
      <div class="sac__font-18 semi-bold">Recent Cycle Details</div>
    </div>
    <div class="cycle-table margin-top-16">
      <v-data-table
        :headers="headers"
        :items="tableData"
        :loading="loadingCycles"
        hide-default-footer
      >
        <template #[`item.acMode`]="{ item }">
          <td :class="`table-${item.acMode.toLowerCase()}`">
            {{ item.acMode }}
          </td>
        </template>
        <template #[`item.performance`]="{ item }">
          <td :class="`table-${item.acMode.toLowerCase()}`">
            {{ item.performance }}
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import apiClient from "@shared/lib/general/apiClient";
import formatCycleList from "@shared/lib/util/formatCycleList";
import customerDetailMixin from "@shared/mixins/customerDetailMixin";

export default {
  name: "CycleTable",
  mixins: [customerDetailMixin],
  data() {
    return {
      cycles: [],
      loadingCycles: false,
      headers: [
        {
          text: "AC Mode",
          align: "start",
          sortable: false,
          filterable: false,
          value: "acMode",
        },
        {
          text: "Thermostat Zone",
          align: "start",
          sortable: false,
          filterable: false,
          value: "zone",
        },
        {
          text: "OA Temp/RH",
          align: "start",
          sortable: false,
          filterable: false,
          value: "oaTemp",
        },
        {
          text: "Delta P",
          align: "start",
          sortable: false,
          filterable: false,
          value: "deltaP",
        },
        {
          text: "Performance",
          align: "start",
          sortable: false,
          filterable: false,
          value: "performance",
        },
        {
          text: "Sup/Ret",
          align: "start",
          sortable: false,
          filterable: false,
          value: "supRet",
        },
        {
          text: "Leak",
          align: "start",
          sortable: false,
          filterable: false,
          value: "leakTemp",
        },
        {
          text: "Runtime",
          align: "start",
          sortable: false,
          filterable: false,
          value: "runtime",
        },
        {
          text: "Date",
          align: "start",
          sortable: false,
          filterable: false,
          value: "date",
        },
      ],
    };
  },
  computed: {
    ...mapState({
      tZoneList: (state) => state.customerDetail.tZones,
      selectedUnit: (state) => state.customerDetail.selectedUnit,
    }),
    zoneMap() {
      return this.tZoneList.reduce((acc, item) => {
        acc[item.serialNumber] = item.zone;
        return acc;
      }, {});
    },
    tableData() {
      if (!this.cycles.length) {
        return [];
      }
      const { thermostatZones } = this.selectedUnit || {};
      if (thermostatZones && thermostatZones.length > 0) {
        const zoneSerials = thermostatZones.map((tz) => tz.serialNumber);
        const filtered = this.cycles.filter((cycle) => zoneSerials.includes(cycle.uid));
        return formatCycleList(
          filtered.slice(0, 10),
          this.customerPartnerSettings,
          this.zoneMap
        );
      }
      return formatCycleList(
        this.cycles.slice(0, 10),
        this.customerPartnerSettings,
        this.zoneMap
      );
    },
  },
  watch: {
    tZoneList: {
      immediate: true,
      handler(zones) {
        if (zones && zones.length > 0) {
          this.fetchCycles(zones);
        }
      },
    },
  },
  methods: {
    async fetchCycles(zones) {
      this.loadingCycles = true;
      try {
        const requests = zones.map((tz) =>
          apiClient({
            method: "GET",
            url: `/devices/acCycle/last/30/${tz.serialNumber}`,
          })
        );
        const responses = await Promise.all(requests);
        const allCycles = responses.flatMap((res) => res.data || []);

        allCycles.sort((a, b) => new Date(b.startTime) - new Date(a.startTime));

        this.cycles = allCycles;
      } catch (err) {
        console.error("Failed to fetch recent cycles:", err);
        this.cycles = [];
      } finally {
        this.loadingCycles = false;
      }
    },
  },
};
</script>

<style lang="scss">
.cycle-table {
  .v-data-table__wrapper {
    table {
      border-spacing: 0 8px !important;
      thead {
        tr {
          th {
            border-bottom: 0 !important;
            color: $BLACK !important;
            font-size: 14px;
            font-weight: 600;
            height: 30px;
            text-transform: uppercase;
          }
        }
      }
      tbody {
        tr {
          td {
            height: 54px;
            border-bottom: 0 !important;
            font-size: 14px;
            background-color: $N5;
            &:first-child {
              border-top-left-radius: 8px;
              border-bottom-left-radius: 8px;
            }
            &:last-child {
              border-top-right-radius: 8px;
              border-bottom-right-radius: 8px;
            }
          }
        }
      }
    }
  }
  .table-cool {
    color: #2766e4;
    font-size: 14px;
    font-weight: 700;
  }
  .table-heat {
    color: #eb0a0e;
    font-size: 14px;
    font-weight: 700;
  }
  .table-fan {
    color: black;
    font-size: 14px;
    font-weight: 700;
  }
}
</style>
